import { useState } from "react";

import type { QUESTION_RESULT_STATUSES } from "models";

export const useDealerQualityChecksFilterValues = () => {
  const [mechanicId, setMechanicId] = useState<number>();
  const [locationId, setLocationId] = useState<number>();
  const [qcOfficerId, setQcOfficerId] = useState<number>();
  const [qcStatus, setQcStatus] = useState<QUESTION_RESULT_STATUSES>();
  const [qcChecklistId, setQcChecklistId] = useState<number>();

  return {
    mechanicId,
    locationId,
    qcOfficerId,
    qcStatus,
    qcChecklistId,
    setMechanicId,
    setLocationId,
    setQcOfficerId,
    setQcStatus,
    setQcChecklistId
  };
};
